module.exports = __webpack_public_path__ + "static/img/1481_phase_function_Paper_Points.0eaa177.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1481_phase_function_Paper_Points.png
// module id = Wdyy
// module chunks = 0